// extracted by mini-css-extract-plugin
export default {"row":"TeamUsersTableRow_row__gLGBk","actions":"TeamUsersTableRow_actions__Z5ws-","text":"TeamUsersTableRow_text__XlQEE","remove":"TeamUsersTableRow_remove__EeAf7"};